export const ARJUN_OIL_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },

  {
    Header: "Activity",
    Footer: "Activity",
    accessor: "activity",
  },
  {
    Header: "Reward Point",
    Footer: "Reward Point",
    accessor: "rewardpoint",
  },
  {
    Header: "Location",
    Footer: "Location",
    accessor: "location",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
    // Cell: ({ value }) => {
    // 	return format(new Date(value), "dd/MM/yyyy");
    // },
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];
